<script setup lang="ts">
defineProps({
  label: {
    type: String,
    default: 'Date :',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
  errorMessage: String,
})

const modelValue = defineModel<string>()
</script>

<template>
  <label class="form-control w-full">
    <div class="label font-semibold">
      <span class="label-text"> {{ label }} <span v-if="required" class="text-red-500">*</span> </span>
    </div>
    <input
      type="date"
      class="input input-bordered input-sm w-full"
      :class="{ 'border-red-500': errorMessage }"
      v-model="modelValue"
      :disabled="disabled"
      :required="required"
    />
    <span v-if="errorMessage" class="text-red-500 text-sm mt-1">{{ errorMessage }}</span>
  </label>
</template>
